<template>
  <div id="view">
    <historyTag :historyArr="historyArr"></historyTag>

    <div id="mainBox" class="flex">
      <!-- 左侧：分类树 -->
      <div class="categorySidebar" v-show="pageShow == 'index'">
        <div class="sidebarHeader">
          <span>分类管理</span>
          <el-button type="primary" size="mini" @click="openCategoryDialog()">+ 新增</el-button>
        </div>
        <el-tree
          :data="categoryTree"
          :props="{ label: 'categoryName', children: 'children' }"
          node-key="categoryId"
          :default-expand-all="true"
          :highlight-current="true"
          @node-click="handleCategoryClick"
          @node-contextmenu="handleCategoryContextMenu"
          ref="categoryTreeRef"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ data.categoryName }}</span>
            <span class="treeActions">
              <i class="el-icon-edit" @click.stop="openCategoryDialog(data)"></i>
              <i class="el-icon-delete" @click.stop="delCategoryFn(data)"></i>
            </span>
          </span>
        </el-tree>
      </div>

      <!-- 右侧：问题列表/编辑 -->
      <div class="contentMain" :class="{ 'fullWidth': pageShow != 'index' }">
        <!-- 问题列表 -->
        <div class="bannerList" v-show="pageShow == 'index'">
          <div class="topBox flex">
            <ul class="flex">
              <li class="flex">
                <div style="width: 240px">
                  <el-input v-model="searchVle" placeholder="请输入问题标题" @keyup.enter="searchFn"></el-input>
                </div>
              </li>
              <li class="flex" style="margin-left:15px">
                <el-button type="success" size="small" @click="searchFn">搜索</el-button>
              </li>
            </ul>
            <el-button type="success" size="small" @click="addFn">新增问题</el-button>
          </div>

          <template>
            <el-table border :data="tableData" style="width: 100%">
              <el-table-column prop="question" align="center" label="常见问题" min-width="200"></el-table-column>
              <el-table-column align="center" label="所属分类" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.categoryName || '未分类' }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="排序" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="sortQuestionFn(scope.row, 1)">↑</el-button>
                  <span>{{ scope.row.sortOrder || 0 }}</span>
                  <el-button type="text" size="small" @click="sortQuestionFn(scope.row, -1)">↓</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">
                    {{ scope.row.status == 1 ? '启用' : '禁用' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="success" size="small" @click="editFn(scope.$index)">编辑</el-button>
                  <el-button type="danger" size="small" @click="delFn(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div class="page_box">
            <el-pagination @current-change="changePage" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next,jumper" :total="tableTotal">
            </el-pagination>
          </div>
        </div>

        <!-- 新增/编辑问题表单 -->
        <div class="addBanner" v-show="pageShow == 'add'">
          <div class="bannnerLi flex">
            <div class="title">所属分类：</div>
            <div style="width: 300px">
              <el-popover
                placement="bottom-start"
                trigger="click"
                v-model="categorySelectVisible"
                width="280"
              >
                <div class="treeSelectBox">
                  <el-input
                    v-model="categoryFilterText"
                    placeholder="搜索分类"
                    size="mini"
                    clearable
                    style="margin-bottom: 8px"
                  ></el-input>
                  <div class="treeScroll">
                    <el-tree
                      :data="categoryTree"
                      :props="{ label: 'categoryName', children: 'children' }"
                      node-key="categoryId"
                      :default-expand-all="true"
                      :highlight-current="true"
                      :filter-node-method="filterCategoryNode"
                      @node-click="selectCategory"
                      ref="selectTree"
                    ></el-tree>
                  </div>
                </div>
                <el-input
                  slot="reference"
                  v-model="selectedCategoryName"
                  placeholder="请选择分类"
                  readonly
                  suffix-icon="el-icon-arrow-down"
                  clearable
                  @clear="listInfo.categoryId = null"
                ></el-input>
              </el-popover>
            </div>
          </div>

          <div class="bannnerLi flex">
            <div class="title">常见问题：</div>
            <div style="width: 500px">
              <el-input v-model="listInfo.question" placeholder="请输入标题"></el-input>
            </div>
          </div>

          <div class="bannnerLi flex">
            <div class="title">排序号：</div>
            <div style="width: 150px">
              <el-input-number v-model="listInfo.sortOrder" :min="0" placeholder="0"></el-input-number>
            </div>
          </div>

          <div class="bannnerLi flex">
            <div class="title">状态：</div>
            <div>
              <el-switch v-model="listInfo.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用"></el-switch>
            </div>
          </div>

          <div class="bannnerLi flex">
            <div class="title">详情介绍：</div>
            <div style="width: 800px">
              <wangEditor :initText="listInfo.depict" @myEditorContent="(res) => { this.listInfo.depict = res; }"></wangEditor>
            </div>
          </div>

          <div class="bannnerLi flex">
            <el-button type="success" size="small" @click="submitFn">提交</el-button>
            <el-button type="info" size="small" @click="returnFn">返回</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 分类新增/编辑弹窗 -->
    <el-dialog title="分类管理" :visible.sync="categoryDialogVisible" width="400px">
      <el-form :model="categoryForm" label-width="80px">
        <el-form-item label="分类名称">
          <el-input v-model="categoryForm.categoryName" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="父分类">
          <el-popover
            placement="bottom-start"
            trigger="click"
            v-model="parentCategorySelectVisible"
            width="280"
          >
            <div class="treeSelectBox">
              <div class="treeScroll">
                <el-tree
                  :data="categoryTreeWithRoot"
                  :props="{ label: 'categoryName', children: 'children' }"
                  node-key="categoryId"
                  :default-expand-all="true"
                  :highlight-current="true"
                  @node-click="selectParentCategory"
                  ref="parentTree"
                ></el-tree>
              </div>
            </div>
            <el-input
              slot="reference"
              v-model="parentCategoryName"
              placeholder="请选择父分类"
              readonly
              suffix-icon="el-icon-arrow-down"
              clearable
              @clear="categoryForm.parentId = 0"
            ></el-input>
          </el-popover>
        </el-form-item>
        <el-form-item label="排序号">
          <el-input-number v-model="categoryForm.sortOrder" :min="0" placeholder="0"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="categoryForm.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="categoryDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCategoryFn">确定</el-button>
      </div>
    </el-dialog>

    <!-- 右键菜单 -->
    <el-dropdown-menu :visible.sync="categoryMenuVisible" :style="{ left: categoryMenuPosition.x + 'px', top: categoryMenuPosition.y + 'px' }">
      <el-dropdown-item @click.native="openCategoryDialog()">新增分类</el-dropdown-item>
      <el-dropdown-item @click.native="openCategoryDialog(currentCategory)">编辑分类</el-dropdown-item>
      <el-dropdown-item @click.native="delCategoryFn(currentCategory)" divided>删除分类</el-dropdown-item>
    </el-dropdown-menu>
  </div>
</template>

<script>
import { delTips, throttle } from "@/util/utils";
import wangEditor from "@/components/wangEditor";
import elUpload from "@/components/elUpload";
export default {
  components: {
    wangEditor,
    elUpload,
  },
  data() {
    return {
      // 页面状态
      historyArr: ["常见问题"],
      pageShow: "index",
      submitShow: false,

      // 问题列表
      searchVle: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,

      // 问题表单
      listInfo: {
        question: "",
        depict: "",
        categoryId: null,
        sortOrder: 0,
        status: 1,
      },

      // 分类数据
      categoryTree: [],
      flatCategoryList: [],
      selectedCategoryId: null,

      // 分类树选择器（问题表单）
      categorySelectVisible: false,
      categoryFilterText: "",

      // 分类弹窗
      categoryDialogVisible: false,
      parentCategorySelectVisible: false,
      categoryForm: {
        categoryId: null,
        categoryName: "",
        parentId: 0,
        sortOrder: 0,
        status: 1,
      },

      // 右键菜单
      categoryMenuVisible: false,
      categoryMenuPosition: { x: 0, y: 0 },
      currentCategory: null,
    };
  },
  mounted() {
    this.selListFn(1);
    this.loadCategoryTree();
  },
  computed: {
    /** 问题表单中已选分类名称 */
    selectedCategoryName() {
      if (!this.listInfo.categoryId) return "";
      var node = this.flatCategoryList.find(
        (item) => item.categoryId === this.listInfo.categoryId
      );
      return node ? node.categoryName : "";
    },
    /** 带顶级节点的分类树（用于父分类选择） */
    categoryTreeWithRoot() {
      return [
        { categoryId: 0, categoryName: "顶级分类", children: this.categoryTree },
      ];
    },
    /** 分类弹窗中已选父分类名称 */
    parentCategoryName() {
      if (!this.categoryForm.parentId) return "顶级分类";
      var node = this.flatCategoryList.find(
        (item) => item.categoryId === this.categoryForm.parentId
      );
      return node ? node.categoryName : "";
    },
  },
  watch: {
    /** 分类搜索过滤 */
    categoryFilterText(val) {
      if (this.$refs.selectTree) {
        this.$refs.selectTree.filter(val);
      }
    },
  },
  methods: {
    // ==================== 问题列表 ====================

    /** 查询问题列表（支持分类+关键词筛选） */
    selListFn(page) {
      var obj = {
        page: page || this.currentPage,
        size: this.pageSize,
      };
      if (this.searchVle) obj.question = this.searchVle;
      if (this.selectedCategoryId != null) obj.categoryId = this.selectedCategoryId;
      this.$https(this.$api.api.selQuestion, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    /** 搜索 */
    searchFn() {
      this.currentPage = 1;
      this.selListFn(1);
    },

    /** 翻页 */
    changePage() {
      this.selListFn();
    },

    /** 新增问题 */
    addFn() {
      this.historyArr.push("新增");
      this.pageShow = "add";
      this.submitShow = false;
      this.listInfo = {
        question: "",
        depict: "",
        categoryId: this.selectedCategoryId || null,
        sortOrder: 0,
        status: 1,
      };
    },

    /** 编辑问题 */
    editFn(index) {
      var list = this.tableData[index];
      this.historyArr.push("编辑");
      this.pageShow = "add";
      this.listInfo = {
        id: list.id,
        question: list.question,
        depict: list.depict,
        categoryId: list.categoryId,
        sortOrder: list.sortOrder || 0,
        status: list.status !== undefined ? list.status : 1,
      };
    },

    /** 删除问题 */
    delFn: delTips(function (index) {
      var list = this.tableData[index];
      this.$https(this.$api.api.delQuestion, { id: list.id }, "GET").then((res) => {
        if (res.data.code == 200) {
          this.submitShow = false;
          this.$message.success("操作成功");
          this.selListFn(this.currentPage);
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    /** 问题排序（direction: 1上移 -1下移） */
    sortQuestionFn(row, direction) {
      this.$https(this.$api.api.sortQuestion, { id: row.id, sortOrder: direction }, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("排序调整成功");
          this.selListFn(this.currentPage);
        } else {
          this.$message.error("排序调整失败");
        }
      });
    },

    /** 提交问题（新增/编辑） */
    submitFn: throttle(function () {
      var data = this.listInfo;
      if (!data.question) return this.$message.error("请输入常见问题");
      if (!data.depict) return this.$message.error("请输入详情介绍");

      var obj = {
        question: data.question,
        depict: data.depict,
        categoryId: data.categoryId || 0,
        sortOrder: data.sortOrder || 0,
        status: data.status !== undefined ? data.status : 1,
      };
      var urls = this.$api.api.addQuestion;
      if (data.id) {
        urls = this.$api.api.upQuestion;
        obj.id = data.id;
      }
      this.submitShow = true;
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.returnFn();
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    /** 返回列表页 */
    returnFn() {
      this.historyArr.pop();
      this.pageShow = "index";
      this.selListFn(1);
    },

    // ==================== 分类管理 ====================

    /** 加载分类树 */
    loadCategoryTree() {
      this.$https(this.$api.api.getQuestionCategoryTree, {}, "POST").then((res) => {
        if (res.data.code == 200) {
          this.categoryTree = res.data.data;
          this.flatCategoryList = this.flattenTree(res.data.data);
        }
      });
    },

    /** 扁平化分类树（用于查找） */
    flattenTree(nodes) {
      var result = [];
      var traverse = function (node) {
        result.push(node);
        if (node.children && node.children.length > 0) {
          node.children.forEach(traverse);
        }
      };
      nodes.forEach(traverse);
      return result;
    },

    /** 分类搜索过滤 */
    filterCategoryNode(value, data) {
      if (!value) return true;
      return data.categoryName.indexOf(value) !== -1;
    },

    /** 点击左侧分类，筛选问题列表 */
    handleCategoryClick(data) {
      this.selectedCategoryId = data.categoryId;
      this.currentPage = 1;
      this.selListFn(1);
    },

    /** 右键分类节点 */
    handleCategoryContextMenu(event, data) {
      event.preventDefault();
      this.currentCategory = data;
      this.categoryMenuPosition = { x: event.clientX, y: event.clientY };
      this.categoryMenuVisible = true;
      document.addEventListener("click", this.closeCategoryMenu);
    },

    /** 关闭右键菜单 */
    closeCategoryMenu() {
      this.categoryMenuVisible = false;
      document.removeEventListener("click", this.closeCategoryMenu);
    },

    /** 问题表单：选择分类 */
    selectCategory(data) {
      this.listInfo.categoryId = data.categoryId;
      this.categorySelectVisible = false;
    },

    /** 分类弹窗：选择父分类 */
    selectParentCategory(data) {
      this.categoryForm.parentId = data.categoryId;
      this.parentCategorySelectVisible = false;
    },

    /** 打开分类弹窗（data为空则新增，有值则编辑） */
    openCategoryDialog(data) {
      if (data) {
        this.categoryForm = {
          categoryId: data.categoryId,
          categoryName: data.categoryName,
          parentId: data.parentId || 0,
          sortOrder: data.sortOrder || 0,
          status: data.status || 1,
        };
      } else {
        this.categoryForm = {
          categoryId: null,
          categoryName: "",
          parentId: this.selectedCategoryId || 0,
          sortOrder: 0,
          status: 1,
        };
      }
      this.categoryDialogVisible = true;
    },

    /** 删除分类（校验子分类和关联问题） */
    delCategoryFn(data) {
      this.$confirm("确定删除该分类？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$https(this.$api.api.delQuestionCategory, { id: data.categoryId }, "GET").then((res) => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.loadCategoryTree();
            if (this.selectedCategoryId === data.categoryId) {
              this.selectedCategoryId = null;
              this.selListFn(1);
            }
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      }).catch(() => {});
    },

    /** 提交分类（新增/编辑） */
    submitCategoryFn() {
      if (!this.categoryForm.categoryName) {
        return this.$message.error("请输入分类名称");
      }
      var url = this.categoryForm.categoryId
        ? this.$api.api.upQuestionCategory
        : this.$api.api.addQuestionCategory;
      this.$https(url, this.categoryForm, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.categoryDialogVisible = false;
          this.loadCategoryTree();
        } else {
          this.$message.error("操作失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  position: relative;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  align-items: flex-start;

  .categorySidebar {
    width: 260px;
    flex-shrink: 0;
    border-right: 1px solid #e6e6e6;
    padding-right: 15px;
    margin-right: 15px;
    display: flex;
    flex-direction: column;
    height: 70vh;

    .sidebarHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      font-weight: bold;
      font-size: 14px;
      flex-shrink: 0;
    }

    /deep/ .el-tree {
      flex: 1;
      overflow-y: auto;
      min-height: 0;
    }

    .custom-tree-node {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .treeActions {
        visibility: hidden;
        font-size: 14px;

        .el-icon-edit {
          color: #409eff;
          margin-right: 8px;
          cursor: pointer;
        }

        .el-icon-delete {
          color: #f56c6c;
          cursor: pointer;
        }
      }

      &:hover .treeActions {
        visibility: visible;
      }
    }
  }

  .contentMain {
    flex: 1;
    display: block;

    &.fullWidth {
      width: 100%;
    }
  }

  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
    justify-content: space-between;
  }

  .bannerTop {
    margin-bottom: 20px;
  }

  .el-header {
    height: 50px !important;
    line-height: 50px;
    border-bottom: 2px solid #bebebe;
  }

  .banner {
    width: 100%;
    overflow: hidden;

    .el-icon-plus,
    img {
      width: 200px;
      height: 110px;
      border: 2px dashed #dedede;
      line-height: 120px;
      text-align: center;
      font-size: 28px;
      color: #999;
    }

    .Btn {
      background: red;
      margin-left: 15px;
    }
  }

  .bannerImg {
    width: 180px;
    height: 70px;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bannerList {
    width: 100%;
  }

  .addBanner {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;
  }

  .bannnerLi {
    width: 100%;
    margin-bottom: 30px;

    .title {
      width: 110px;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/problem/index.vue